import {storyblokEditable, useStoryblokApi} from "@storyblok/react";
import ButtonGroup from "../partials/ButtonGroup";
import {transformImage} from "../../utils/StoryblokService";
import StatsGroup from "../partials/StatsGroup";
import LinePattern from "../partials/LinePattern";
import {richTextResolver} from "@storyblok/richtext";

/**
 * from-cyan-600 via-cyan-600 bg-cyan
 * from-yellow-600 via-yellow-600 bg-yellow
 * from-gray-600 via-gray-600 bg-gray
 * from-orange-600 via-orange-600 bg-orange
 * from-blue-600 via-blue-600 bg-blue
 * from-green-600 via-green-600 bg-cyan
 */
export default function TwoColumnImageAndStats(props: any) {
    const { render } = richTextResolver()
    const blok = props.blok;

    return (
        <div className="relative bg-white py-16 sm:py-16"  {...storyblokEditable(blok)}>
            <div className="lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:items-start lg:gap-24 lg:px-8">
                <div className="relative lg:py-16 lg:py-0 h-full">
                    <div aria-hidden="true" className="hidden lg:block lg:absolute lg:inset-y-0 lg:right-0 lg:w-screen">
                        <div className="absolute inset-y-0 right-1/2 w-full rounded-r-3xl bg-warm-gray-50 lg:right-72"/>


                        <LinePattern
                            class={'top-8 left-1/2 -ml-3 lg:-right-8 lg:left-auto lg:top-12 opacity-10 transform scale-75'}/>

                    </div>
                    <div className="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:px-0 lg:pt-20 lg:pb-10 h-full">
                        {/* Testimonial card*/}
                        <div className="relative overflow-hidden rounded-2xl pt-64 pb-10 shadow-xl h-full">
                            <img
                                className="absolute inset-0 h-full w-full object-cover"
                                src={transformImage(blok?.image?.filename, "1120x712")}
                                alt={blok.image.alt}
                            />
                            {blok.gradient && <>
                                <div className={`absolute inset-0 bg-primary/50 mix-blend-multiply`}/>
                                <div
                                    className={"absolute inset-0 bg-gradient-to-t opacity-90 " + `from-gray-300 via-gray-600`}/>
                            </>
                            }
                            <div className="relative px-8">
                                <div>
                                    {blok.logo.filename &&
                                        <img
                                            className="h-12"
                                            src={transformImage(blok?.logo?.filename, "300x150")}
                                        />
                                    }
                                </div>
                                {blok.quote &&
                                <blockquote className="mt-8">
                                    <div className="relative text-lg font-medium text-white md:flex-grow">
                                        <svg
                                            className="absolute top-0 left-0 h-8 w-8 -translate-x-3 -translate-y-2 transform text-secondary opacity-25"
                                            fill="currentColor"
                                            viewBox="0 0 32 32"
                                            aria-hidden="true"
                                        >
                                            <path
                                                d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"/>
                                        </svg>
                                        <p className="relative">
                                            {blok.quote}
                                        </p>
                                    </div>

                                    <footer className="mt-4">
                                        <p className="text-base font-semibold text-white">
                                            {blok.author}
                                        </p>
                                    </footer>
                                </blockquote>}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0">
                    {/* Content area */}
                    <div className="pt-12 sm:pt-16 lg:pt-20">
                        <h2 className={"font-bold tracking-tight text-gray-900 "+blok.titlesize}>
                            {blok.title}
                        </h2>
                        <div className="mt-6 space-y-6 text-gray-700 rich-text">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: render(blok.text) as string
                                }}
                            >
                            </div>
                        </div>
                    </div>

                    {/* Stats section */}
                    <div className="mt-10">
                        <dl className="grid grid-cols-2 gap-x-4 gap-y-8">
                            <StatsGroup stats={blok.stats}/>
                        </dl>
                        <div className="mt-10">
                            <ButtonGroup buttons={blok.buttons}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
